export default __webpack_public_path__ + "static/media/dailydash.75cd52e0.jpg";